import { useEffect, type RefObject } from 'react';

type Event = MouseEvent | TouchEvent;

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: Event) => void,
  excludeRef?: RefObject<HTMLElement | null>,
) {
  useEffect(() => {
    const listener = (event: Event) => {
      const targetNode = event.target as Node;
      if (!ref.current || ref.current.contains(targetNode)) {
        return;
      }
      if (excludeRef?.current?.contains(targetNode)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, excludeRef]);
}
